import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import PastoralPagination from "../../components/pagination";
import FollowUpFilter from "../../components/followUpFilter";
import { MailingContext } from "../../../../contexts/MailingContext";
import { useNavigate } from "react-router-dom";
import InventoryModal from "../../components/fullfillment/InventoryModal";

export const Inventory = (props) => {
  const source = props.source ? props.source : "";
  const { getInventory, searchValue, sortOrder, filter, updateInventory } =
    useContext(MailingContext);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [resources, setResources] = useState({ data: [], total: 0 });
  const [resourceUpdated, setResourceUpdated] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [activeTab, setActiveTab] = useState("physical");
  const navigate = useNavigate();
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleApiCall = async (id, newValue) => {
    // This function is kept for backward compatibility
    // Inline editing is now handled through the modal
    console.log("Inline editing deprecated, use modal instead");
  };

  const handleAddInventory = () => {
    setEditItem(null);
    setShowModal(true);
  };

  const handleEditInventory = (item) => {
    setEditItem(item);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditItem(null);
    setResourceUpdated(resourceUpdated + 1); // Refresh the list
  };

  const handleToggleActive = async (resource) => {
    console.log("Toggle clicked for resource:", resource);
    console.log("Resource ID:", resource.id, "Resource ID field:", resource.id);
    console.log("All resource fields:", Object.keys(resource));

    // Use the correct ID field name
    const resourceId = resource.inventoryID;
    console.log("Using resource ID:", resourceId);

    if (!resourceId) {
      console.error("No ID found for resource:", resource);
      return;
    }

    try {
      const newActiveStatus =
        resource.activeStatus === "active" ? "inactive" : "active";
      console.log("Updating to new status:", newActiveStatus);
      const result = await updateInventory(resourceId, {
        activeStatus: newActiveStatus,
      });
      console.log("Update result:", result);
      setResourceUpdated(resourceUpdated + 1); // Refresh the list
    } catch (error) {
      console.error("Error updating active status:", error);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchValue, filter, activeTab]);

  useEffect(() => {
    getInventory("", currentPage, source, activeTab).then((results) => {
      setResources(results.data);
    });
  }, [currentPage, searchValue, sortOrder, filter, resourceUpdated, activeTab]);
  return (
    <>
      <div className="justify-end">
        <FollowUpFilter context={MailingContext} showTitle={true} />
      </div>
      <Wrapper className=" m-5 px-3">
        <Header className="px-5 p-3 mt-4 justify-between">
          <div className="flex-1">
            <div className="text-center">
              <TableHeading> INVENTORY LIST</TableHeading>
            </div>
            <TabContainer className="justify-center">
              <TabButton
                active={activeTab === "physical"}
                onClick={() => setActiveTab("physical")}
              >
                Physical
              </TabButton>
              <TabButton
                active={activeTab === "digital"}
                onClick={() => setActiveTab("digital")}
              >
                Digital
              </TabButton>
            </TabContainer>
          </div>
          <AddButton onClick={handleAddInventory}>+ Add Inventory</AddButton>
        </Header>
        {resources.data ? (
          <>
            <Table>
              <thead>
                <TableHeaderRow>
                  <th className="text-center">Title</th>
                  {activeTab === "physical" && (
                    <>
                      <th className="text-center">Quantity Available</th>
                      {/* <th className="text-center">Quantity On Hold</th> */}
                      <th className="text-center">Dispatcher</th>
                    </>
                  )}
                  {activeTab === "digital" && (
                    <>
                      {/* <th className="text-center">Quantity Available</th> */}
                      <th className="text-center">URL</th>
                    </>
                  )}
                  <th className="text-center">Active</th>
                  <th className="text-center">Actions</th>
                </TableHeaderRow>
              </thead>
              <tbody>
                {resources.data.map((resource) => {
                  console.log("Resource in table:", resource);
                  return (
                    <TableRow key={resource.inventoryID}>
                      <td className="p-2">{resource.title}</td>
                      {activeTab === "physical" && (
                        <>
                          <td className="p-2 text-center">
                            <div className="p-2 flex justify-center">
                              {" "}
                              <Physical className="status p-1 m-1">
                                {resource.quantityAvailable || 0}
                              </Physical>
                            </div>
                          </td>
                          {/* <td className="p-2 text-center">
                            <div className="p-2 flex justify-center">
                              {" "}
                              <Physical className="status p-1 m-1">
                                {resource.quantityOnHold || 0}
                              </Physical>
                            </div>
                          </td> */}
                          <td className="p-2 text-center">
                            <div className="p-2 flex justify-center">
                              {" "}
                              <Physical className="status p-1 m-1">
                                {resource.distributor || "N/A"}
                              </Physical>
                            </div>
                          </td>
                        </>
                      )}
                      {activeTab === "digital" && (
                        <>
                          {/* <td className="p-2 text-center">
                            <div className="p-2 flex justify-center">
                              {" "}
                              <Physical className="status p-1 m-1">
                                {resource.quantityAvailable || 0}
                              </Physical>
                            </div>
                          </td> */}
                          <td className="p-2 text-center">
                            <div className="p-2 flex justify-center">
                              {" "}
                              <Physical className="status p-1 m-1">
                                {resource.url || "N/A"}
                              </Physical>
                            </div>
                          </td>
                        </>
                      )}
                      <td className="p-2 text-center">
                        <ToggleSwitch
                          checked={resource.activeStatus !== "inactive"}
                        >
                          <input
                            type="checkbox"
                            checked={resource.activeStatus !== "inactive"}
                            onChange={() => handleToggleActive(resource)}
                            style={{ cursor: "pointer" }}
                          />
                        </ToggleSwitch>
                      </td>
                      <td className="p-2 text-center">
                        <ActionButton
                          onClick={() => handleEditInventory(resource)}
                        >
                          Edit
                        </ActionButton>
                      </td>
                    </TableRow>
                  );
                })}
              </tbody>
            </Table>
          </>
        ) : (
          <div className="d-flex justify-content-center">
            <div
              className="spinner-border"
              role="status"
              style={{ width: "6em", height: "6em" }}
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </Wrapper>
      {resources?.total > 0 && (
        <PastoralPagination
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          total_count={resources.total}
          handlePageChange={handlePageChange}
        />
      )}

      <InventoryModal
        show={showModal}
        onHide={handleModalClose}
        editItem={editItem}
        defaultType={activeTab}
      />
    </>
  );
};

export default Inventory;

const Wrapper = styled.div`
  background-color: white;
  border-radius: 20px;
`;

const TableHeading = styled.span`
  color: #ec3310;
  text-align: center;
  font-family: "Space Grotesk";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 3.5px;
`;

const TableHeaderRow = styled.tr`
  border-bottom-color: #c9cfda;
  border-bottom-width: 1.5px;
  border-bottom-style: solid;
`;
const TableRow = styled.tr`
  border-bottom-color: #c9cfda;
  border-bottom-width: 1.5px;
  border-bottom-style: solid;

  &:hover {
    background-color: #f1f1f1;
  }
`;
const Table = styled.table`
  width: 100%;
  font-family: Space Grotesk;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Physical = styled.span`
  border: 1px solid #00323b;
  background: #eefdff;
  color: #00323b;
`;
const Digital = styled.span`
  border: 1px solid #ff7234;
  background: #ffeae4;
  color: #ff7234;
`;

const AddButton = styled.button`
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #2563eb;
  }
`;

const ActionButton = styled.button`
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #e5e7eb;
  }
`;

const TabContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

const TabButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  background-color: ${(props) => (props.active ? "#3b82f6" : "#ffffff")};
  color: ${(props) => (props.active ? "#ffffff" : "#374151")};
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${(props) => (props.active ? "#2563eb" : "#f3f4f6")};
  }
`;

const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  background-color: ${(props) => (props.checked ? "#3b82f6" : "#ccc")};
  border-radius: 24px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:after {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: white;
    top: 3px;
    left: ${(props) => (props.checked ? "29px" : "3px")};
    transition: left 0.3s;
  }

  input {
    opacity: 0;
    width: 50px;
    height: 24px;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: 1;
  }
`;
